import { SideNavigationProps } from "@amzn/awsui-components-console";

import { ChatHistoryItem } from "@/types/chat-history";
import { truncateText } from "@/utils/utils";

import ChatNavOptions from "./ChatNavOptions";

export const createChatNavItem = (
  item: ChatHistoryItem
): SideNavigationProps.Link => ({
  type: "link",
  text: truncateText(item.title),
  href: `/?thread=${item.id}`,
  info: <ChatNavOptions chatItem={item} />,
});
